const phoneNumberCta = document.querySelector('.lrd-number-cta');
const footer = document.querySelector('.lrd-footer');

if (phoneNumberCta && footer) {
    // Configuration de l'Intersection Observer pour observer directement le footer
    const observerOptions = {
        root: null, // viewport
        rootMargin: '0px',
        threshold: 0
    };
    
    // Callback de l'observer
    function handleIntersection(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Le CTA entre dans le footer, le masquer
                phoneNumberCta.style.opacity = '0';
                phoneNumberCta.style.pointerEvents = 'none';
            } else {
                // Le CTA sort du footer, l'afficher
                phoneNumberCta.style.opacity = '1';
                phoneNumberCta.style.pointerEvents = 'auto';
            }
        });
    }
    
    // Créer et démarrer l'observer directement sur le footer
    const observer = new IntersectionObserver(handleIntersection, observerOptions);
    observer.observe(footer);
}